import { useMutation } from 'react-query';

import { downloadCsvFile as mutationFn } from 'api/endPoints/downloadCsvFile';

export const useMutationDownloadCsvFile = () => {
    return useMutation<unknown, QueryError, QueryParams>((params) => mutationFn(params));
};

interface QueryParams {
    fileName: string;
    downloadName: string;
}
